import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '@/utils';
import { FormattedMessage, useIntl } from 'react-intl';

const ResetPasswordEnterCode = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const inputRefs = Array.from({ length: 6 }, () => useRef());

  const otpSchema = Yup.object().shape({
    otp: Yup.string()
      .required(intl.formatMessage({ id: 'AUTH.OTP.VALIDATION.REQUIRED' }))
      .matches(/^[0-9]{6}$/, intl.formatMessage({ id: 'AUTH.OTP.VALIDATION.INVALID_FORMAT' }))
  });

  const formik = useFormik({
    initialValues: { otp: '' },
    validationSchema: otpSchema,
    onSubmit: (values) => {
      navigate('/auth/reset-password/change');
    }
  });

  // Xử lý nhập từng ô
  const handleInputChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const otpArr = formik.values.otp.split('');
    otpArr[index] = value;
    const newOtp = otpArr.join('').padEnd(6, '');
    formik.setFieldValue('otp', newOtp);
    if (value && index < 5) {
      inputRefs[index + 1].current?.focus();
    }
    if (!value && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
  };

  return (
    <div className="card max-w-[380px] w-full">
      <form className="card-body flex flex-col gap-5 p-10" onSubmit={formik.handleSubmit}>
        <img src={toAbsoluteUrl('/media/illustrations/30.svg')} className="dark:hidden max-h-[130px]" alt="" />
        <img src={toAbsoluteUrl('/media/illustrations/30-dark.svg')} className="light:hidden max-h-[130px]" alt="" />

        <div className="text-center mb-2">
          <h3 className="text-lg font-medium text-gray-900 mb-5">
            <FormattedMessage id="AUTH.OTP.ENTER_CODE_TITLE" />
          </h3>
          <div className="flex flex-col">
            <span className="text-2sm text-gray-700 mb-1.5">
              <FormattedMessage id="AUTH.OTP.ENTER_CODE_DESC" />
            </span>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5">
          {[...Array(6)].map((_, index) => (
            <input
              key={index}
              ref={inputRefs[index]}
              id={`otp-input-${index}`}
              type="text"
              maxLength={1}
              className="input focus:border-primary-clarity focus:ring focus:ring-primary-clarity size-10 shrink-0 px-0 text-center"
              value={formik.values.otp[index] || ''}
              onChange={e => handleInputChange(index, e.target.value)}
              onFocus={e => e.target.select()}
              autoFocus={index === 0}
            />
          ))}
        </div>
        {formik.touched.otp && formik.errors.otp && (
          <div className="text-danger text-xs text-center mt-2">{formik.errors.otp}</div>
        )}

        <button type="submit" className="btn btn-primary flex justify-center mt-4">
          <FormattedMessage id="AUTH.OTP.CONFIRM" />
        </button>

        <div className="flex items-center justify-center mb-2">
          <span className="text-xs text-gray-700 me-1.5">
            <FormattedMessage id="AUTH.OTP.NOT_RECEIVE" />
          </span>
          <Link to="#" className="text-xs link">
            <FormattedMessage id="AUTH.OTP.RESEND" />
          </Link>
        </div>
      </form>
    </div>
  );
};
export { ResetPasswordEnterCode };